import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';

export default function ArticlePage() {
  const article = articleData['sugargoo-warehouse-guide'];
  return <ArticleLayout article={article} />;
}